import { api } from '@/services/api'
export default {
  props: {
    mainID: { required: true },
    sectionID: { required: true },
    hasCreateNew: { type: Boolean, required: true }
  },
  created () {
    this.$bus.$on('Call-Update-Section', this.handleUpdateSection)
    this.$bus.$on(`Call-Validate-Section-${this.sectionID}`, this.validateSection)
    this.$bus.$on(`Call-Save-Section-${this.sectionID}`, this.saveSection)
  },
  beforeDestroy () {
    this.$bus.$off('Call-Update-Section', this.handleUpdateSection)
    this.$bus.$off(`Call-Validate-Section-${this.sectionID}`, this.validateSection)
    this.$bus.$off(`Call-Save-Section-${this.sectionID}`, this.saveSection)
  },
  data () {
    return {
      data: {},
      formData: {},
      isLoading: false
    }
  },
  methods: {
    validateSection (callback) {
      callback()
    },
    saveSection (callback) {
      callback()
    },
    handleUpdateSection () {
      this.requestGetData()
    },
    handleFormData (Data) {
      this.formData = Data
    },
    handleRequestGetData (Data) {
      this.data = Object.assign({}, Data)
    },
    requestGetData () {
      if (!this.mainID) {
        return
      }
      this.isLoading = true
      api
        .get(`${this.checkEs6AndRun(this.apiGet, { mainID: this.mainID })}`)
        .then(response => {
          this.handleRequestGetData(response.data.value[0])
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error)
        })
        .then(() => {
          this.isLoading = false
        })
    }
  }
}
